// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3oyuw","label":"Radio_label__1pT-c","checkMark":"Radio_checkMark__3BhRG","disabled":"Radio_disabled__NM5ci"};